import dynamic from "next/dynamic";
import PropTypes from "prop-types";
import { createGlobalStyle } from "styled-components";
import Header from "./header";
import { CSSResets } from "../styles/reset";
import CTABanner from "./LandingPage/CTABanner";
import SEOForMarketingPage from "./newSeo";

const IntercomWrapper = dynamic(() => import("../utils/Intercom"), {
	ssr: false,
});

const GlobalStyle = createGlobalStyle`
  ${CSSResets};
`;

const SeoLayout = ({ children, title, metaTitle, description }) => (
	<>
		<IntercomWrapper />
		<GlobalStyle />
		<SEOForMarketingPage
			title={title}
			metaTitle={metaTitle}
			description={description}
		/>
		<CTABanner id="cta-banner-mobile-view" />
		<Header siteTitle={title} />
		<main>{children}</main>
	</>
);

SeoLayout.propTypes = {
	children: PropTypes.node.isRequired,
	title: PropTypes.string.isRequired,
};

export default SeoLayout;
